import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=55310bea&"
import script from "./deviceDetails.vue?vue&type=script&lang=js&"
export * from "./deviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports